// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1kUli","paramInput":"JobSimulator_paramInput__38di5","input":"JobSimulator_input__2bvxT"};